/** Normalize source metadata casing for display without changing stored titles. */
export function formatLegalTitle(title: string): string {
  if (title !== title.toUpperCase() && !/[A-Z]{5,}/.test(title)) return title;
  return title
    .toLowerCase()
    .replace(/\b[a-z]/g, (letter) => letter.toUpperCase())
    .replace(/\b(Of|And|The|For|To|In)\b/g, (word, offset: number) =>
      offset === 0 ? word : word.toLowerCase(),
    );
}
